import { Options } from "src/app/shared/google-places/google-place.directive";
import { AbstractGooglePlaces } from "./abstract-google-places";

export class DbsGooglePlaces implements AbstractGooglePlaces {
  public getGooglePlacesOptions(): Options {
    return {
      types: ["address"],
      componentRestrictions: { country: ["sg"] },
    } as unknown as Options;
  }
}
